 $(document).ready(function(){
  
    $(".dm_color_active").each(function(){
      var variant_title_1 = $(this).attr("option-value");
      $(this).parents(".dm_main_collection_product").find(".dm_main_product_variant_title_e").text(variant_title_1);
    });
    
    // $('body').on("click",".dm_main_product_button_size, .dm_products_size_overlay, .dm_products_size_close", function(){
  
    //   $(this).parents(".dm_main_collection_product").find(".dm_products_size_overlay").toggleClass("dm_products_size_overlay_e");
    //   $(this).parents(".dm_main_collection_product").find(".dm_products_size").toggleClass("dm_products_size_e");
      
    // });
   
  $('body').on("click",".u_search_drawer .dm_main_product_button_size,.u_search_drawer .dm_products_size_overlay,.u_search_drawer .dm_products_size_close", function(){
     
      $(this).parents(".dm_main_collection_product").find(".dm_products_size_overlay").toggleClass("dm_products_size_overlay_e");
      $(this).parents(".dm_main_collection_product").find(".dm_products_size").toggleClass("dm_products_size_e");
      
    });
    $(".dm_main_product_value_label").change(function(){
      var variant_title = $(this).children().attr("option-value");
      $(this).parents(".dm_main_collection_product").find(".dm_main_product_variant_title_e").text(variant_title);
	});

    $(".dm_main_product_value_label, .dm_products_size_value_label").change(function(){
      let selectedVal = '';
      $(this).parents(".dm_main_collection_product").find(".dm_main_product_value_input:checked, .dm_products_size_value_input:checked").each(function(){
        selectedVal += $(this).attr("option-value");
      });
      final_selectedVal = selectedVal.substring(0,selectedVal.length).trim();
      $(this).parents(".dm_main_collection_product").find(".dm_swatch option").each(function(){
        if ($(this).text().trim() == final_selectedVal ){
          $(this).parents(".dm_main_collection_product").find(".dm_swatch").val($(this).val()).trigger("change");
          var NewImage = $(this).attr("var-image");
          $(this).parents(".dm_main_collection_product").find(".dm_main_product_image img").attr("src", NewImage);
          var MainValue = $(this).attr("var-main-value");
          $(this).parents(".dm_main_collection_product").attr("product-data", MainValue);
        }
      });
    });
  });

  var swiper = new Swiper(".dm_main_collection_product .mySwiper", {
    slidesPerView: 4.8,
    spaceBetween: 5,
    freeMode: true,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
